<template>
    <div class="listen-visits">
      <div class="listen-visits-top">
          <div class="title">听评课访问</div>
          <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
      </div>
      <div class="listen-visits-echarts">
          <div style="width: 100%;height: 100%" id="listenVisitsEchartsId"></div>
      </div>
      <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
      <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
      <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
      <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
  </template>
  <script>
  import * as echarts from 'echarts';
  export default {
    name: 'listen-visits',
    data() {
      return {
  
      }
    },
    methods: {
      initEcharts(){
          let dom = document.getElementById('listenVisitsEchartsId')
          let myChart = echarts.init(dom);
          let option;
          option = {
              xAxis: {
                  name:"时间",
                  type: 'category',
                  boundaryGap: false,
                  data: ['3月', '4月', '5月', '6月', '7月', '8月', '9月'],
                  axisTick: {
                      alignWithLabel: true,
                      show:false,
                  },
                  axisLine: {
                      show: false,
                      lineStyle: {
                          color: "#D6D6D6",
                      },
                  },
              },
              yAxis: {
                  name: '访问数量',
                  type: 'value',
                  axisLine: {
                      show: false,
                      lineStyle: {
                          color: "#D6D6D6",
                      },
                  },
                  axisLabel: {
                      show: true,
                      verticalAlign: "middle",
                      textStyle: {
                          color: "#6EA0D3",
                      },
                  },
                  splitLine: {
                      show: false,
                  },
                  axisTick:{
                    show:false,
                  }
              },
              series: [
                  {
                      data: [820, 932, 901, 934, 1290, 1330, 1320],
                      type: 'line',
                      areaStyle: {},
                      smooth: true,
                      lineStyle:{
                          color:"#24AB6D"
                      },
                      itemStyle: {  
                        color: '#24AB6D'
                      },
                      areaStyle: {  
                          color: {  
                              type: 'linear',  
                              x: 0,  
                              y: 0,  
                              x2: 0,  
                              y2: 1,  
                              colorStops: [  
                                  {offset: 0, color: '#061135'},   // 0% 处的颜色  
                                  {offset: 1, color: '#245D7C'}   // 100% 处的颜色  
                              ],  
                              global: false   // 缺省为 false  
                          }  
                      } 
                  }
              ]
          };
          option && myChart.setOption(option);
      }
    },
    mounted(){
      this.initEcharts();
    }
  }
  </script>
  <style lang='scss' scoped>
  .listen-visits{
      width: 100%;
      height: 350px;
      padding: 0 15px;
      border: 1px solid #053882;
      position: relative;
      margin-bottom: 20px;
    //   background: rgba(6,17,52,0.8);
      .listen-visits-top{
          position: relative;
          text-align: center;
          // margin-bottom: 18px;
          .title{
              display: inline-block;
              padding: 9px 22px 8px 17px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #D0E7FE;
              line-height: 20px;
              position: relative;
              z-index: 2;
          }
          .more{
              display: inline-block;
              position: absolute;
              top: 0px;
              right: 0px;
              height: 100%;
              line-height: 44px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #359AFF;
              cursor: pointer;
          }
          .title-bg{
              width: auto;
              height: 100%;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
          }
      }
      .listen-visits-echarts{
          width: 100%;
          height: calc(100% - 40px);
      }
      .top-left{
          position: absolute;
          top: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .top-right{
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
      .left-bottom{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .right-bottom{
          position: absolute;
          bottom: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
  }
  </style>